import { createFileRoute } from "@tanstack/react-router"

import { OverviewPage } from "~/components/design-system/pages"
import { DataQualityOverview } from "~/components/ingestion-cockpit/data-quality/DataQualityOverview"

export const Route = createFileRoute("/_auth/ingestion-cockpit/_layout/data-quality/")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <OverviewPage>
      <DataQualityOverview />
    </OverviewPage>
  )
}
